import { ValueFormHealthAddress } from "../../../../../../constants/health";

import { AddressDataDto, AddressDataItem, DefaultAddressDataDto } from "./address-form-item-dto";
import { AddressData } from "./address-form-item-types";

export function getStoredPreviousData(addressData: AddressDataDto): AddressDataDto {
  const previousData: AddressDataDto = JSON.parse(JSON.stringify(addressData));

  previousData.address.errorCode = "";
  previousData.number.errorCode = "";
  previousData.portalValue.errorCode = "";
  previousData.stairsValue.errorCode = "";
  previousData.floorValue.errorCode = "";
  previousData.doorValue.errorCode = "";
  previousData.postalCode.errorCode = "";
  previousData.town.errorCode = "";
  previousData.province.errorCode = "";
  previousData.country.errorCode = "";

  return previousData;
}

export function getPreviousData(previousData: AddressDataDto, addressData: AddressDataDto) {
  addressData.address = previousData.address;
  addressData.wayType = previousData.wayType;
  addressData.postalCode = previousData.postalCode;
  addressData.town = previousData.town;
  addressData.province = previousData.province;
  addressData.provinceLabel = previousData.province.value;
  addressData.country = previousData.country;

  addressData.number = previousData.number;
  addressData.doorValue = previousData.doorValue;
  addressData.floorValue = previousData.floorValue;
  addressData.portalValue = previousData.portalValue;
  addressData.stairsValue = previousData.stairsValue;
  addressData.normalizaDireciones = previousData.normalizaDireciones;

  addressData.sameAsTaker = false;

  previousData = DefaultAddressDataDto({ defaultCountry: { value: "ESPAÑA", code: "ESPA" } });
  return { previousData, addressData };
}

function getValueFormHealthAddress(
  value: string | AddressDataItem | undefined,
  disabled: boolean
): ValueFormHealthAddress {
  if (!value || typeof value === "string") {
    return {
      value: value ? value : "",
      label: "",
      errorCode: "",
      disabled: disabled,
      code: "",
    };
  } else {
    return {
      value: value.value,
      label: value.label,
      errorCode: "",
      disabled: disabled,
      code: value.code,
    };
  }
}

export function getFormatedAddressData(
  addressData: AddressDataDto,
  newData: AddressData,
  disabled: boolean
): AddressDataDto {
  addressData.address = getValueFormHealthAddress(newData.address, disabled);
  addressData.wayType = newData.wayType;
  addressData.postalCode = getValueFormHealthAddress(newData.postalCode, disabled);
  addressData.town = getValueFormHealthAddress(newData.town, disabled);
  addressData.province = getValueFormHealthAddress(newData.province, disabled);
  addressData.number = getValueFormHealthAddress(newData.number, disabled);
  addressData.doorValue = getValueFormHealthAddress(newData.door, disabled);
  addressData.floorValue = getValueFormHealthAddress(newData.floor, disabled);
  addressData.portalValue = getValueFormHealthAddress(newData.portal, disabled);
  addressData.stairsValue = getValueFormHealthAddress(newData.stairs, disabled);
  addressData.normalizaDireciones = newData.normalizaDireciones;
  addressData.sameAsTaker = newData.sameAsTaker;
  addressData.country = getValueFormHealthAddress(newData.country, disabled);

  return addressData;
}

export function getChangeNormalizedAddress(
  addressData: AddressDataDto,
  normalizaDireciones: "N" | "S"
) {
  // Si de no normalizado pasa a normalizado
  // limpia los datos para coger los correctos normalizados
  if (normalizaDireciones === "S") {
    addressData.province = {
      ...addressData.province,
      value: "",
      label: "",
      code: "",
      errorCode: "",
    };
    addressData.town = {
      ...addressData.town,
      value: "",
      label: "",
      errorCode: "",
      disabled: true,
    };
    addressData.address = {
      ...addressData.address,
      value: "",
      label: "",
      errorCode: "",
      disabled: true,
    };
    addressData.postalCode = {
      ...addressData.postalCode,
      value: "",
      label: "",
      errorCode: "",
      disabled: true,
    };
    addressData.country = {
      ...addressData.country,
      value: "ESPAÑA",
      label: "",
      code: "ESPA",
      errorCode: "",
      disabled: false,
    };
  } else {
    addressData.province = {
      ...addressData.province,
      errorCode: "",
      disabled: false,
    };
    addressData.town = {
      ...addressData.town,
      errorCode: "",
      disabled: false,
    };
    addressData.address = {
      ...addressData.address,
      errorCode: "",
      disabled: false,
    };
    addressData.postalCode = {
      ...addressData.postalCode,
      errorCode: "",
      disabled: false,
    };
    addressData.country = {
      ...addressData.country,
      errorCode: "",
      disabled: false,
    };
  }
  return addressData;
}

export function validateNoErrors(addressData: AddressDataDto): {
  noErrors: boolean;
  addressData: AddressDataDto;
} {
  let noErrors = true;

  //Validación código postal
  if (!addressData.postalCode.value) {
    addressData.postalCode.errorCode = "required";
    noErrors = false;
  }

  //Validación población
  if (!addressData.town.value) {
    addressData.town.errorCode = "required";
    noErrors = false;
  }

  //Validación provincia
  // Con país extranjero la provincia no es requerida
  if (!addressData.province.value && addressData.country.code === "ESPA") {
    addressData.province.errorCode = "required";
    noErrors = false;
  }

  //Validación domicilio
  if (!addressData.address.value) {
    addressData.address.errorCode = "required";
    noErrors = false;
  }

  //Validación número/km
  if (!addressData.number.value) {
    addressData.number.errorCode = "required";
    noErrors = false;
  }

  //Si el checkAddress dió error
  if (
    addressData.number.errorCode === "invalid-address" ||
    addressData.address.errorCode === "invalid-address" ||
    addressData.province.errorCode === "invalid-address" ||
    addressData.town.errorCode === "invalid-address" ||
    addressData.postalCode.errorCode === "invalid-address"
  ) {
    noErrors = false;
  }
  return { noErrors, addressData };
}

function mapAddressDataItem(item: ValueFormHealthAddress): AddressDataItem {
  return {
    value: item.value,
    code: item.code,
    label: item.label,
  };
}

export function getValidFormattedData(
  addressData: AddressDataDto,
  isVisaProduct: boolean | undefined
): AddressData {
  return {
    address: mapAddressDataItem(addressData.address),
    wayType: addressData.wayType,
    number: addressData.number.value,
    portal: addressData.portalValue.value,
    stairs: addressData.stairsValue.value,
    floor: addressData.floorValue.value,
    door: addressData.doorValue.value,
    postalCode: addressData.postalCode.value,
    town: mapAddressDataItem(addressData.town),
    province: mapAddressDataItem(addressData.province),
    sameAsTaker: addressData.sameAsTaker,
    normalizaDireciones: addressData.normalizaDireciones,
    ...(isVisaProduct ? { country: mapAddressDataItem(addressData.country) } : {}),
  };
}
